import { render, staticRenderFns } from "./EcommerceDataCenterLayout.vue?vue&type=template&id=5bb98e34&scoped=true&"
import script from "./EcommerceDataCenterLayout.vue?vue&type=script&lang=js&"
export * from "./EcommerceDataCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceDataCenterLayout.vue?vue&type=style&index=0&id=5bb98e34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb98e34",
  null
  
)

export default component.exports